import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { ILpCanvasComponent, ILpCanvasElementContext } from '@gametailors/leerplus';
import { LpMissionInfo, LpRidHomeworkStopCanvasComponent } from '../../../../typings/schema';
import { RidButton } from '../../../components';
import { CockpitMockService, THomeworkAssignmentActivity } from '../../../services/cockpit/cockpit-mock-service.service';
import { LEERPLUS, wrapInMission } from '../../rid-game.utils';

@Component({
  selector: 'rid-homework-stop-canvas-component',
  imports: [RidButton],
  templateUrl: './rid-homework-stop-canvas-component.html',
})
export class RidHomeworkStopCanvasComponent implements OnInit, ILpCanvasComponent<LpRidHomeworkStopCanvasComponent> {
  protected readonly $lpApiService = inject(LEERPLUS.apiToken);
  private readonly $cockpitMockService = inject(CockpitMockService);

  comp = input.required<LpRidHomeworkStopCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  assignments = signal<THomeworkAssignmentActivity[] | undefined>(undefined);
  missions = computed(() => this.assignments()?.map((a) => wrapInMission(a)));

  isFinished(mission: LpMissionInfo): boolean {
    const mp = this.$lpApiService.state().missionProgress.find((mp) => mp.uid === mission.uid);
    if (!mp) return false;

    return !!mp.finished_timestamp;
  }

  async ngOnInit(): Promise<void> {
    this.assignments.set(await this.$cockpitMockService.getHomeworkConfig(this.comp().uid));
  }
}
